import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaReceipt } from "react-icons/fa";
import Projects from "./Projects";
import "../assets/css/DigixLeads.css";
import "../assets/css/Projects.css";

/**
 * Projects module page: Projects + Project Estimation tabs only.
 * User Stories and Tasks live under separate PMS nav routes.
 */
function ProjectManagement({
  projects = [],
  loading = false,
  onAddProjectClick,
  onViewProject,
  onEditProject,
  onFetchProjects,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Projects");
  const [dashboardProjectStatusPreset, setDashboardProjectStatusPreset] = useState("");
  const [projectsFetched, setProjectsFetched] = useState(false);

  useEffect(() => {
    const s = location.state;
    if (!s || typeof s !== "object") return;
    let applied = false;
    if (s.projectManagementTab === "Projects" || s.projectManagementTab === "Project Estimation") {
      setActiveTab(s.projectManagementTab);
      applied = true;
    }
    if (s.projectManagementTab === "User Stories") {
      navigate("/user-stories", { replace: true, state: null });
      return;
    }
    if (s.projectManagementTab === "Tasks") {
      navigate("/tasks", { replace: true, state: { dashboardTaskStatusPreset: s.dashboardTaskStatusPreset } });
      return;
    }
    if (typeof s.dashboardProjectStatusPreset === "string") {
      setDashboardProjectStatusPreset(s.dashboardProjectStatusPreset);
      applied = true;
    }
    if (applied) {
      navigate(".", { replace: true, state: null });
    }
  }, [location.state, navigate]);

  useEffect(() => {
    if (!onFetchProjects || projectsFetched) return;
    onFetchProjects({});
    setProjectsFetched(true);
  }, [onFetchProjects, projectsFetched]);

  const tabs = useMemo(() => ["Projects", "Project Estimation"], []);

  return (
    <div className="projects-container project-management-container">
      <div className="main-card project-management-main-card">
        <div className="project-management-tabs-row">
          <div className="tabs-container">
            {tabs.map((t) => (
              <button
                key={t}
                type="button"
                className={`tab-button ${activeTab === t ? "active" : ""}`}
                onClick={() => setActiveTab(t)}
              >
                {t === "Project Estimation" ? "Estimation" : t}
              </button>
            ))}
          </div>
          {activeTab === "Projects" ? (
            <button
              type="button"
              className="btn-add-lead project-management-generate-receipt-btn"
              onClick={() => navigate("/projects/generate-receipt")}
            >
              <FaReceipt style={{ marginRight: 8 }} aria-hidden />
              Generate Receipt
            </button>
          ) : null}
        </div>

        {activeTab === "Projects" ? (
          <div className="project-management-projects-tab">
            <Projects
              projects={projects}
              loading={loading}
              onAddProjectClick={onAddProjectClick}
              onViewProject={onViewProject}
              onEditProject={onEditProject}
              onFetchProjects={onFetchProjects}
              dashboardProjectStatusPreset={dashboardProjectStatusPreset}
            />
          </div>
        ) : null}

        {activeTab === "Project Estimation" ? (
          <div
            className="project-management-tab-content project-management-project-estimation-tab"
            aria-label="Project estimation"
          />
        ) : null}
      </div>
    </div>
  );
}

export default ProjectManagement;
